export default __webpack_public_path__ + "static/media/0164.52ad8c83.jpg";